<template>
    <!-- <v-app> -->
      <!-- <login/> -->
    <div class="Dashboard">
        <!-- <introduction /> -->
      <!-- <main class="main"> -->
          <input-container class="input-container-main" />
          <sample-dashboard  :style="showSampleDashboard" 
          view="SampleDashboard" :studySelected="studySelected" /> 
          <heatmap-container :style="showHeatmap" 
          view="Heatmap" :studySelected="studySelected" />
          <boxplot-container :style="showBoxplot" view="Boxplot" :studySelected="studySelected"/>
          <scatterplot-container :style="showScatterplot" view="Scatterplot" :studySelected="studySelected"/>
          <!-- <scatterplot-container :style="showScatterplot" view="Scatterplot" /> -->
          <pfs-curveplot-container :style="showPfsCurveplot" view="PfsCurveplot" :studySelected="studySelected"/>
          <!-- <quality-control-container :style="showQualityControl" view="Quality control" /> -->
          <!-- <histology-viewer-container :style="showHistologyViewer" view="Histology viewer" /> -->
      <!-- </main> -->
    </div>
    <!-- </v-app> -->
  </template>
  
  <script>
//   import Login from './components/Login.vue';
  import BoxplotContainer from '../components/Boxplot/BoxplotContainer.vue';
  import HeatmapContainer from '../components/Heatmap/HeatmapContainer.vue';
  // import HistologyViewerContainer from './HistologyViewerContainer.vue';
  import InputContainer from '../components/InputContainer.vue';
  // import Introduction from '../components/Header/Introduction.vue';
  import ScatterplotContainer from '../components/Scatterplot/ScatterplotContainer.vue';
  import SampleDashboard from '../components/SampleDashboard.vue';
  import PfsCurveplotContainer from '../components/PFSCurveplot/PfsCurveplotContainer.vue';
  // import Login from './components/Login.vue';
  // import QualityControlContainer from './components/QualityControlContainer.vue';
  
  export default {
    name: 'Dashboard',
  
    components: {
    //   Login,
      BoxplotContainer,
      HeatmapContainer,
      // HistologyViewerContainer,
      InputContainer,
      // Introduction,
      SampleDashboard,
      ScatterplotContainer,
      PfsCurveplotContainer,
      // QualityControlContainer,
    },
  
    data: () => ({
    }),
  
    computed: {
      studySelected() { 
          console.log('studySelected', this.$route.path)
          if (this.$route.path === '/pcc') {
              return 'PCC'
          } else {
              return 'PTRC'
          }
      },
      view() { return this.$store.state.view },
      showBoxplot() { return this.view === 'Boxplot' ? "" : "display: none;" },
      // showDemo() { return this.view === 'Demo' ? "" : "display: none;" },
      showHeatmap() { return this.view === 'Heatmap' ? "" : "display: none;" },
      // showIprofun() { return this.view === 'Iprofun' ? "" : "display: none;" },
      showSampleDashboard() { return this.view === 'Sample dashboard' ? "" : "display: none;" },
      showScatterplot() { return this.view === 'Scatterplot' ? "" : "display: none;" },
      showQualityControl() { return this.view === 'Quality control' ? "" : "display: none;" },
      showHistologyViewer() { return this.view === 'Histology viewer' ? "" : "display: none;" },
      showPfsCurveplot() { 
        console.log('showPfsCurveplot container', this.view)
        return this.view === 'Survival curve plot' ? "" : "display: none;" },
    },
  
    mounted() { 
        this.$store.dispatch('getTracks', 
            { 
              view: 'Heatmap', 
              genes: ['LXN', 'ARVCF'],
              combine_bool: true,
            }
          )
    },
    watch: {
      studySelected() {

      }

    }
  };
  </script>
  
  <style scoped>
  html {
      box-sizing: border-box;
  }
  
  *, *:before, *:after {
      box-sizing: inherit;
  }
  
  #app {
      font-family: Avenir, Helvetica, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      color: #2c3e50;
  }
  
  .Dashboard {
      display: flex;
      flex-direction: row;
      width: 100%;
    }
  
  .right-panel {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
  }
  </style>